import styled from 'styled-components'

export const CatalogItemDetailsSourceStyled = styled.div`
  display: flex;
  align-items: center;
  gap: ${(props) => props.theme.space.small};
  min-width: 0;
`
